import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import store from 'core/store';

const history = syncHistoryWithStore(hashHistory, store, {
  adjustUrlOnReplay : false, // the URL will not be kept in sync during time travel
  selectLocationState: (state) => {
    return state.routing;
  }
});

export default history;



// WEBPACK FOOTER //
// ./src/core/history.js